import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Shop from "../pages/Shop";
import ShopBySort from "../pages/ShopBySort";
import Cart from "../pages/Cart";
import CreateProduct from "../pages/admin/CreateProduct";
import AllProducts from "../pages/admin/AllProducts";
import UpdateProduct from "../pages/admin/UpdateProduct";
import { useCart } from "../context/cart-context";
import { ShopView } from "../pages/ShopView";
import LoginPage from "../pages/auth/LoginPage";
import { Checkout } from "../pages/auth/Checkout";
import useOnline from "../hooks/use-online";
import ErrorBoundaryPage from "../Error/ErrorBoundaryPage";
import SignUpPage from "../pages/auth/SignUpPage";
import { AuthContext } from "../context/auth-context";
import { About } from "../pages/About";
import { Contact } from "../pages/Contact";
import { Bookings } from "../pages/Bookings";
import Wishlist from "../pages/Wishlist";
import BackdropLoader from "../components/Loading/BackdropLoader";
import DashboardLayout from "../components/Dashboard/DashboardLayout";
import DashboardOverview from "../components/Dashboard/DashboardOverview";
import AdminOverview from "../components/Dashboard/AdminOverview";
import TransactionsTable from "../components/Dashboard/TransactionsTable";
import BookingsTable from "../components/Dashboard/BookingsTable";
import { Settings } from "../components/Dashboard/Settings";
import AdminBookingSchedule from "../components/Dashboard/AdminBookingSchedule";
import AdminServicesManager from "../components/Dashboard/AdminServicesManager";
import AdminAvailability from "../components/Dashboard/AdminAvailability";

export const Navigator = () => {
  const { isLoading } = useCart();
  // const { isLoading, setIsLoading } = React.useContext(DataContext);

  const userIsOnline = useOnline();

  const { isAuthenticated } = React.useContext(AuthContext);

  let newUser = JSON.parse(localStorage.getItem("user"));
  // console.log("newUser", newUser.role);

  const ProtectedRoute = ({ element, ...rest }) => {
    if (isAuthenticated) {
      return element;
    } else {
      return <Navigate to="/login" replace />;
    }
  };

  const AdminProtectedRoute = ({ element, ...rest }) => {
    if (newUser.role === "admin") {
      return element;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  };

  return (
    <React.Fragment>
      {userIsOnline ? (
        <>
          {isLoading && <BackdropLoader open={isLoading} />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<ShopBySort />} />
            <Route path="/shop/view/:slug/:id" element={<ShopView />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/wishlist" element={<Wishlist />} />

            {/* Protected Route Begins */}

            <Route
              path="/dashboard"
              element={<ProtectedRoute element={<DashboardLayout />} />}
            >
              <Route
                index
                element={newUser?.role === "admin" ? <AdminOverview /> : <DashboardOverview />}
              />
              <Route path="orders" element={<TransactionsTable />} />
              <Route path="bookings" element={<BookingsTable />} />
              <Route path="settings" element={<Settings />} />
              <Route
                path="admin/create"
                element={<AdminProtectedRoute element={<CreateProduct />} />}
              />
              <Route
                path="admin/products"
                element={<AdminProtectedRoute element={<AllProducts />} />}
              />
              <Route
                path="admin/schedule"
                element={<AdminProtectedRoute element={<AdminBookingSchedule />} />}
              />
              <Route
                path="admin/availability"
                element={<AdminProtectedRoute element={<AdminAvailability />} />}
              />
              <Route
                path="admin/services"
                element={<AdminProtectedRoute element={<AdminServicesManager />} />}
              />
              <Route
                path="admin/update/:slug/:id"
                element={<AdminProtectedRoute element={<UpdateProduct />} />}
              />
            </Route>

            <Route
              path="/checkout"
              element={<ProtectedRoute element={<Checkout />} />}
            />
            {/* Protected Route Ends */}

            {/* <Route path="/sample" element={<Sample />} /> */}
          </Routes>
        </>
      ) : (
        <ErrorBoundaryPage
          title="No connection"
          content="It looks like you are offline. Please check your internet connection."
          buttonLabel="Retry"
          onButtonClick={() => window.location.reload()}
          includeFooter
        />
      )}
    </React.Fragment>
  );
};
